import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { useBreakpoints } from "../../../../hooks/useBreakpoins";

interface Props {
  onChange: (val: Date) => void;
  value: Date;
  placeholder: string;
}

export function CustomDatePicker({ onChange, value, placeholder }: Props) {
  const { isSmalldesktop } = useBreakpoints();
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        sx={{
          width: "100%",
          ml: isSmalldesktop ? 0 : 0.5,
          mt: 1,
        }}
        slotProps={{ textField: { variant: "standard" } }}
        label={placeholder}
        value={value}
        onChange={(newValue) => onChange(newValue)}
        format="dd/MM/yyyy"
      />
    </LocalizationProvider>
  );
}
